module.exports = __webpack_public_path__ + "img/image4.b9da388e.jpg";